module.exports = __webpack_public_path__ + "static/media/puzzleClue4.8046164f.png";